import { useImmerReducer } from 'use-immer'

import { reducerContext, initialData, DataType, reducer, Action } from './useReducerContext'

export default function ReducerContextProvider({ children }) {
  const [contextData, dispatch] = useImmerReducer<DataType, Action>(reducer, initialData)
  return (
    <reducerContext.Provider value={[contextData, dispatch]}>{children}</reducerContext.Provider>
  )
}
